import React from 'react';
import _ from 'underscore';

import {FromServerProtocol} from 'notebook/ELNConstants';
import ProtocolDAO from 'notebook/protocols/dao/ProtocolDAO';
import * as LegacyModalContainer from 'ui-library/LegacyModalContainer';

import {FolderDefaultsKey} from '../FolderDefaults';
import BaseCreateModal from './BaseCreateModal';

const CREATE_PROTOCOL_MODAL_KEY = 'CreateProtocolModal';

interface Props {
  onRequestClose?: () => void;
}

class CreateProtocolModal extends React.Component<Props> {
  static close(): void {
    LegacyModalContainer.close(CREATE_PROTOCOL_MODAL_KEY);
  }

  static open(modal: typeof CreateProtocolModal, props?: Props): void {
    if (props == null) {
      props = {};
    }
    // eslint-disable-next-line no-restricted-syntax
    props = _.extend({}, props, {
      onRequestClose() {
        LegacyModalContainer.close(CREATE_PROTOCOL_MODAL_KEY);
      },
    });
    LegacyModalContainer.open(CREATE_PROTOCOL_MODAL_KEY, React.createElement(modal, props));
  }

  createProtocol = (name: string, folderId: string): JQueryPromise<string> =>
    ProtocolDAO.create({name, folder: folderId}).then((resp: FromServerProtocol) => resp.id);

  override render(): JSX.Element {
    return (
      <BaseCreateModal
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          title: 'Create protocol',
          create: this.createProtocol,
          showNotebook: true,
          folderDefaultsKey: FolderDefaultsKey.NOTEBOOK,
        })}
        dataTestAttrs={{component: 'CreateProtocolModal', element: 'modal'}}
      />
    );
  }
}

export default CreateProtocolModal;
